import {Component, HostBinding} from '@angular/core';

@Component({
  selector: 'pr-settings',
  templateUrl: './settings.component.html'
})
export class SettingsComponent {
    @HostBinding('class.flex')
    @HostBinding('class.flex-grow')

    tabLinks = [
        { 'path': './features', 'label': 'Cechy' },
        { 'path': './shelves', 'label': 'Regały' },
    ];
}
